class CustomEvent extends Event {
    persist() {}
}

export default CustomEvent;